<p-toast></p-toast>
<p-card>
    <ng-template pTemplate="header">
        <h5 class="pdfs-15">{{ 'ACCOUNT' | translate}}</h5>
    </ng-template>
    <div class="p-grid">
        <div class="p-col-12 p-lg-6">
            <h5 class="customfont1 mt--15">{{ 'FULL_NAME' | translate}}</h5>
            <input [disabled]="true" type="text" class="inputfiled" placeholder="{{ 'FULL_NAME' | translate}}" [(ngModel)]="nombreCompleto" pInputText />
        </div>
        <div class="p-col-12 p-lg-6">
            <h5 class="customfont1 mt--15">{{ 'MAIL' | translate}}</h5>
            <input [disabled]="true" type="text" class="inputfiled" placeholder="{{ 'MAIL' | translate}}" [(ngModel)]="correo" pInputText />
        </div>


        <div class="p-col-12 p-lg-6">
            <h5 class="customfont1 mt-15">{{ 'TYPE_ACCOUNT' | translate}}</h5>
            <p-selectButton [disabled]="true" [options]="stateOptions" [(ngModel)]="tipoCuenta" class="selectCustom" optionLabel="label"
                optionValue="value"></p-selectButton>
        </div>

    </div>
    <ng-template pTemplate="footer">
        <div class="row bt2">
            <button pButton pRipple type="button" icon="pi pi-trash"
                class="p-button-raised p-button-danger p-button-rounded"></button>
            <button pButton pRipple type="button" icon="pi pi-user"
                class="p-button-raised p-button-success p-button-rounded fR" (click)="addSingle()"></button>
        </div>
    </ng-template>
</p-card>